<template>
  <!-- /Around the world  Services -->
  <section class="review-client-section">
    <div class="container">
      <div class="section-heading section-heading-four">
        <div class="row align-items-center row-gap-3">
          <div class="col-md-6 aos" data-aos="fade-up">
            <h2>Reviews from our Clients</h2>
            <p>
              Description highlights the value of client feedback, showcases real
              testimonials
            </p>
          </div>
          <div class="col-md-6 text-md-end aos" data-aos="fade-up">
            <router-link to="/customer/customer-reviews" class="btn btn-primary btn-view"
              >View all Reviews<i class="feather-arrow-right"></i
            ></router-link>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="owl-carousel popular-slider-2 mb-0">
            <Carousel :wrap-around="true" :settings="settings" :breakpoints="breakpoints">
              <Slide v-for="item in indexfourservices" :key="item.id">
                <div class="client-review-main">
                  <div class="client-review-top">
                    <div class="client-review-name mb-2">
                      <h6>{{ item.name }}</h6>
                      <div class="rating">
                        <i class="fas fa-star filled me-1"></i>
                        <i class="fas fa-star filled me-1"></i>
                        <i class="fas fa-star filled me-1"></i>
                        <i class="fas fa-star filled me-1"></i>
                        <i class="fas fa-star filled me-1"></i>
                      </div>
                    </div>
                    <p>
                      {{ item.content }}
                    </p>
                  </div>
                  <span
                    class="client-review-img avatar avatar-xl p-1 bg-white rounded-circle"
                  >
                    <img
                      :src="require(`@/assets/img/profiles/${item.avatar}`)"
                      class="rounded-circle"
                      alt="User"
                    />
                  </span>
                </div>
              </Slide>
              <template #addons>
                <Pagination />
              </template>
            </Carousel>
          </div>
        </div>
      </div>

      <index-five-branch />
    </div>
  </section>
  <!-- /Reviews from our Clients -->
</template>

<script>
import { Carousel, Pagination, Navigation, Slide } from "vue3-carousel";
import indexfourservices from "@/assets/json/indexfourservices.json";
import "vue3-carousel/dist/carousel.css";
export default {
  data() {
    return {
      indexfourservices: indexfourservices,
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
        loop: true,
        margin: 24,
      },

      breakpoints: {
        575: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        // 700px and up
        767: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        // 991px and up
        991: {
          itemsToShow: 2.5,
          snapAlign: "center",
        },
        // 1024 and up
        1024: {
          itemsToShow: 3,
          snapAlign: "start",
        },
      },
    };
  },
  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation,
  },
};
</script>

<style>
.client-review-main {
  margin-right: 24px;
}
</style>
